import { isDefined } from "csi/utility/coreUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CheckboxOption from "./CheckboxOption";

const PrintOptionAutoScale: FunctionComponent = observer(function PrintOptionAutoScale(props) {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		options: {
			printAutoScale,
		},
		setPrintAutoScale,
	} = optionsStore;

	return (
		<>
			{isDefined(printAutoScale) && (
				<CheckboxOption
					label="CustomViewPrintAutoScale"
					onChange={setPrintAutoScale}
					optionValue={printAutoScale}
					paddingLeft={0}
				/>
			)}
		</>
	);
});

export default PrintOptionAutoScale;